import { getStatusClass } from "../../utils/utils";
import "./styles.css";

/**
 * A reusable status badge/tag component
 * @param {string} status - Status code/key (e.g., 'created', 'failed')
 * @param {boolean} isValid - Used to help determine styling (e.g., success)
 */
const StatusTag = ({ status, stepComplete, label, "data-testid": dataTestId }) => {
  const statusClass = getStatusClass(status, stepComplete);
  return (
    <div className={`statusTag ${statusClass}`} data-testid={dataTestId} data-status={status}>
      <span className={statusClass}>{label}</span>
    </div>
  );
};

export default StatusTag;
